import Swal from 'sweetalert2';

// Error messages from api returned as {message: 'error message text'}
export const logError = ({
	error,
	customMessage = 'No custom message from backoffice',
}) => {
	error?.response?.status
		? console.log(
				`ERROR\n
					Status: ${error.response.status}.\n
					Status error: ${error.response.statusText}.\n
					API Message: ${error.response.data?.message}\n
					Backoffice Message: ${customMessage}`
		  )
		: console.log(
				`ERROR\n
					Backoffice message: ${customMessage}\n ${error}`
		  );
};

export const logFormData = (formData) => {
	console.group('FormData');
	for (let pair of formData.entries())
		console.log('key:', pair[0] + ', value: ' + pair[1]);

	console.groupEnd('FormData');
};

/**
 * Aviso de error. Prioriza el mensaje del backend ({ message }) —por ejemplo el 403
 * "Solo lectura: esta acción requiere un administrador."— y, si no lo hay, el del backoffice.
 */
export const alertError = ({ error, customMessage, title }) => {
	const apiMessage = error?.response?.data?.message;
	const message =
		apiMessage ||
		(typeof error === 'string' ? error : null) ||
		customMessage ||
		error?.response?.statusText ||
		'Se ha producido un error.';

	const params = {
		icon: 'error',
		title:
			title ||
			(apiMessage && customMessage && customMessage.length < 60
				? customMessage
				: 'Error'),
		text: message,
		confirmButtonText: 'Cerrar',
		confirmButtonColor: '#005BAA',
	};

	return Swal.fire(params);
};

export const alertInfo = ({ customMessage, title } = {}) => {
	const params = {
		icon: 'info',
		title: title || 'Aviso',
		text: customMessage,
		confirmButtonText: 'Cerrar',
		confirmButtonColor: '#005BAA',
	};

	return Swal.fire(params);
};

export const alertSuccess = ({ customMessage, title } = {}) => {
	const message = customMessage || 'Operación realizada correctamente.';

	const params = {
		icon: 'success',
		title: title || 'Hecho',
		text: message,
		confirmButtonText: 'Cerrar',
		confirmButtonColor: '#005BAA',
	};

	return Swal.fire(params);
};
